export const consts = {
    experiments: {
        fixAnonymousDefine: 'specs.thunderbolt.ComponentsRegistryFixAnonymousDefine',
        noEvalWorkaround: 'specs.thunderbolt.ComponentsRegistryNoEvalWorkaround',
        fixRegistryEnsureComponentLoaderFix: 'specs.thunderbolt.editorElementsRegistryEnsureComponentLoaderFix',
    },
};
//# sourceMappingURL=consts.js.map